class LookBook extends HTMLElement {
  constructor() {
    super();

    this.tabs = this.querySelectorAll("[data-lookbook-tab]");
    this.panels = this.querySelectorAll("[data-lookbook-panel]");
    this.pointButtons = this.querySelectorAll(".lookbook-points-item button");

    this.handleTabs();
    this.handlePoints();
  }

  handleTabs() {
    this.tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        this.setActiveTab(tab.dataset.lookbookTab);
      });

      tab.addEventListener("keydown", (event) => {
        this.handleTabsKeyboard(event);
      });
    });
  }

  handleTabsKeyboard(event) {
    const currentIndex = Array.from(this.tabs).indexOf(event.currentTarget);
    let nextIndex = null;

    switch (event.key) {
      case "ArrowLeft":
        nextIndex = currentIndex - 1 < 0 ? this.tabs.length - 1 : currentIndex - 1;
        break;
      case "ArrowRight":
        nextIndex = currentIndex + 1 >= this.tabs.length ? 0 : currentIndex + 1;
        break;
      case "Home":
        nextIndex = 0;
        break;
      case "End":
        nextIndex = this.tabs.length - 1;
        break;
      default:
        return;
    }

    event.preventDefault();
    this.tabs[nextIndex].focus();
    this.setActiveTab(this.tabs[nextIndex].dataset.lookbookTab);
  }

  setActiveTab(index) {
    this.tabs.forEach((tab) => {
      const isActive = tab.dataset.lookbookTab === index;
      tab.classList.toggle("active", isActive);
      tab.setAttribute("aria-selected", isActive ? "true" : "false");
      tab.tabIndex = isActive ? 0 : -1;
    });

    this.panels.forEach((panel) => {
      const isActive = panel.dataset.lookbookPanel === index;
      panel.toggleAttribute("hidden", !isActive);
    });
  }

  handlePoints() {
    this.pointButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const points = button.closest(".lookbook-points")?.querySelectorAll("button");

        points?.forEach((point) => {
          point.classList.toggle("active", point === button);
        });
      });
    });
  }
}

if (!customElements.get("look-book")) {
  customElements.define("look-book", LookBook);
}
